'use client';

import React from 'react';

import {ClpPrimaryCtaButton} from '@/features/course-landing-page/components/clp-primary-cta-button/clp-primary-cta-button.react-component';
import styles from './organization-sticky-footer-content.module.scss';

/**
 * OrganizationStickyFooterContent renders the sticky-footer CTA for
 * authenticated organization members. The CTA text/URL/style is driven by
 * useOrgPrimaryCtaButton (via ClpPrimaryCtaButton). Price text is intentionally
 * omitted — pricing isn't surfaced to org users in the sticky footer today.
 */
export const OrganizationStickyFooterContent: React.FC = () => {
    return (
        <div className={styles.container}>
            <ClpPrimaryCtaButton className={styles['enroll-now-cta-button']} udStyle="primary" />
        </div>
    );
};
